/**
 * Generates a Google Docs-style side outline navigation.
 * 
 * @param {string} contentSelector - Selector or ID of the content container (e.g., '#document-body' or 'document-body').
 * @param {string} outlineSelector - Selector or ID of the target nav container (e.g., '#document-outline').
 */
export default function createInPageNav(contentSelector, outlineSelector) {
  // Normalize selectors in case plain IDs without '#' were passed
  const contentEl = contentSelector.startsWith('#') || contentSelector.startsWith('.') 
    ? contentSelector 
    : `#${contentSelector}`;
  const outlineEl = outlineSelector.startsWith('#') || outlineSelector.startsWith('.') 
    ? outlineSelector 
    : `#${outlineSelector}`;

  const $content = $(contentEl);
  const $outline = $(outlineEl);

  if (!$content.length || !$outline.length) {
    return;
  }

  $outline.empty();

  const headers = $content.find('h1, h2, h3, h4').toArray();

  if (!headers.length) {
    return;
  }

  headers.forEach((header, index) => {
    const $header = $(header);

    if ($header.parents('.wp-block-comments').length) {
      return
    }
    
    if (!$header.attr('id')) {
      const slug = $header.text().toLowerCase().trim().replace(/[^\w]+/g, '-');

      $header.attr('id', `${slug}-${index}`);
    }

    const id = $header.attr('id');
    const tagName = header.tagName.toLowerCase();
    const text = $header.text();

    const $link = $('<a></a>')
      .attr('href', `#${id}`)
      .text(text)
      .addClass(`nav-link nav-${tagName}`)
      .data('target-id', id);

    $outline.append($link);
  });

  $outline.off('click', 'a.nav-link').on('click', 'a.nav-link', function (e) {
    e.preventDefault();

    const targetId = $(this).data('target-id');
    const $target = $('#' + targetId);

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - 20
      }, 250);

      history.pushState(null, null, `#${targetId}`);
    }
  });

  const observerOptions = {
    root: null,
    rootMargin: '-10% 0px -70% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        $outline.find('a').removeClass('active');
        $outline.find(`a[href="#${id}"]`).addClass('active');
      }
    });
  }, observerOptions);

  headers.forEach((header) => observer.observe(header));
}